import {
    AffirmIcon,
    AfterpayIcon,
    BankCheckIcon,
    CardIcon,
    CashIcon,
    CircleDotIcon,
    GiftIcon,
    InvoiceIcon,
    KlarnaIcon,
    StoreCreditIcon,
    ZipIcon,
} from "@xola/icons";
import { Tooltip } from "@xola/ui-kit";
import React, { ReactNode } from "react";
import { PaymentMethod } from "types";
import { useSeller } from "../../hooks/useAccount";
import { getPaymentMethodName } from "../../models/Payment";

interface PaymentMethodIconProps {
    method: PaymentMethod | string;
    size?: string;
    className?: string;
    showTooltip?: boolean;
}

export const PaymentMethodIcon = ({
    method,
    size = "medium",
    showTooltip = false,
    className,
}: PaymentMethodIconProps) => {
    const seller = useSeller();

    if (!method) {
        return null;
    }

    // Custom payment methods have string length of 24
    const Icon = method?.length === 24 ? CircleDotIcon : methodIcon[method] ?? CircleDotIcon;

    if (showTooltip) {
        const name = getPaymentMethodName(seller, method);

        if (name) {
            return (
                <Tooltip content={name}>
                    <Icon data-testid={`icon-${method}`} size={size} className={className} />
                </Tooltip>
            );
        }
    }

    return <Icon size={size} className={className} />;
};

const methodIcon: { [key: string]: ReactNode } = {
    [PaymentMethod.CREDIT_CARD]: CardIcon,
    [PaymentMethod.CASH]: CashIcon,
    [PaymentMethod.CHECK]: BankCheckIcon,
    [PaymentMethod.INVOICE]: InvoiceIcon,
    [PaymentMethod.OTHER]: CircleDotIcon,
    [PaymentMethod.STORE_CREDIT]: StoreCreditIcon,
    [PaymentMethod.GIFT]: GiftIcon,
    [PaymentMethod.AFFIRM]: AffirmIcon,
    [PaymentMethod.AFTERPAY]: AfterpayIcon,
    [PaymentMethod.KLARNA]: KlarnaIcon,
    [PaymentMethod.ZIP]: ZipIcon,
};
